/*
* there were two main reasons why we decided to go with JQuery for this functionality
* 1) This code will leave under wordpress and wordpress installation is already loading jquery
* 2) and more important, we are using the the JQuery autocomplete extension for the search input.
*    The extensions did allows to implement what we were looking for with few lines of code. And because we
*    are using some of the extension callbacks/hooks we decided it was just easier to continue to utilise jQuery.
 */

(function ($) {
  $(function () {
    var $searchForm = $('.news-search--result');
    // mirror input span
    $searchForm.append('<span class="hidden-input-mirror"></span>');
    var $hiddenInputMirror = $('.hidden-input-mirror');
    var $searchInput = $("#news-search--result-query");
    appendQueryTexttoHiddenTag()
    var authors = arcgis_object.authors.map(author => `@${author.name}`);
    var tags = arcgis_object.tags.map(tag => `#${tag.name}`);
    var isTagOrAuthor = /^(#|@)/;
    var advSearch = [];
    var newSelection = false;

    // add custom width to autocomplete using jquery
    $.widget("custom.autocomplete", $.ui.autocomplete, {
      _resizeMenu: function () {
        this.menu.element.outerWidth(500);
      }
    });

    // init autocomplete;
    $searchInput.autocomplete({
      source: advSearch,
      minLength: 2,
      _resizeMenu: function () {
        this.menu.element.outerWidth(500);
      }
    });
    // set data attr to true:
    $searchInput.data('autocomplete', true);

    // set or remove autocomplete
    $searchInput.keyup(function () {
      var queryTxt = jQuery(this).val();
      //only check the first character
      if (queryTxt.length < 2) {
        var isSpecialQuery = queryTxt.match(isTagOrAuthor);

        // set hidden-input-mirror to width 0
        $hiddenInputMirror.width(0);

        if (isSpecialQuery) {
          console.log('activate');
          advSearch = queryTxt.indexOf('#') == 0 ? tags : authors;
          $searchInput.autocomplete({
            source: advSearch,
            minLength: 2,
            select: function () {
              newSelection = true;
            },
            close: function () {
              if (newSelection) {
                appendQueryTexttoHiddenTag();
                $('.news-search--result-submit').click();
              }
              newSelection = false;
            },
            _resizeMenu: function () {
              this.menu.element.outerWidth(500);
            }
          });
          $searchInput.data('autocomplete', true);
        } else {
          var isActive = $searchInput.data('autocomplete');
          console.log('isActive', isActive);
          if (isActive) {
            $searchInput.autocomplete("destroy").data('autocomplete', false);
          }
        }
      } else {
        $hiddenInputMirror.text(queryTxt).width('auto');

        if ($hiddenInputMirror.width() >= $searchInput.width()) {
          $searchForm.addClass('overflow-active');
        } else {
          $searchForm.removeClass('overflow-active');
        }
      }

    });

    function appendQueryTexttoHiddenTag() {
      $hiddenInputMirror.text($searchInput.val());
    }

  });



}(jQuery));

/* soso */